import { StringUtils } from "@rsm-hcd/javascript-core";
import Breadcrumb from "atoms/breadcrumbs/breadcrumb";
import React, { useEffect } from "react";
import { match } from "react-router";
import { useHeaderData } from "utilities/contexts/use-header-data-context";
import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";

export interface PagePageBreadcrumbProps {
    match: match;
}
const PagePageBreadcrumb: React.FC<PagePageBreadcrumbProps> = (
    props: PagePageBreadcrumbProps
) => {
    const { currentPage } = useCurrentPage();
    const { match } = props;
    const { setPageTitle } = useHeaderData({ match });

    useEffect(() => {
        setPageTitle(currentPage?.name);
    }, [currentPage, currentPage?.name, setPageTitle]);

    return (
        <Breadcrumb>
            <span className="c-breadcrumb__label">
                {" "}
                {StringUtils.hasValue(currentPage?.name)
                    ? currentPage?.name
                    : "..."}
            </span>
        </Breadcrumb>
    );
};

export default PagePageBreadcrumb;
